import { render, staticRenderFns } from "./RestorationTaskQueue.vue?vue&type=template&id=daa44fb2&scoped=true&"
import script from "./RestorationTaskQueue.vue?vue&type=script&lang=js&"
export * from "./RestorationTaskQueue.vue?vue&type=script&lang=js&"
import style0 from "./RestorationTaskQueue.vue?vue&type=style&index=0&id=daa44fb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa44fb2",
  null
  
)

export default component.exports